export default "__VITE_ASSET__B5k7uUJg__"